<template>
    <div class="base-modal" @click.self="close">
        <div class="base-modal__content" role="dialog" aria-modal="true" aria-labelledby="base-modal-title">
            <header class="base-modal__header spacing-b-5">
                <slot name="header" />
            </header>

            <section class="base-modal__body spacing-b-6">
                <slot />
            </section>

            <footer class="base-modal__footer">
                <slot name="footer" />
            </footer>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            close() {
                this.$emit('close');
            },
        },
    };
</script>

<style scoped lang="scss">
    .base-modal {
        position: fixed;
        inset: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 50;

        &__content {
            background: white;
            border-radius: 24px;
            max-width: 328px;
            width: 90%;
            padding: 24px;
        }
    
        &__header {}
    
        &__footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }

</style>